import React from 'react';
import NoticeTableCell from './NoticeTableCell';
import { NoticeTableCellProps } from './noticeTableCellTypes';

export default function PublisherNameCell({ row }: NoticeTableCellProps) {
  const { original } = row;
  return <NoticeTableCell>{original.publication}</NoticeTableCell>;
}
